import * as ng from 'angular';
import refs from '../../../vendor-modules';
import UserControlsModule from '../../user-controls';
import { AccountRequest, IAccountRequestResource } from './data/account-request';
import { FrequentParkerAccountSummary, IFrequentParkerAccountSummaryResource } from './data/frequent-parker-account-summary';
import { AccountRequestServices, IAccountRequestService } from './services/account-request-service';
import { AccountAdminServices, IAccountAdminService } from './services/accounts-service';
import { FrequentParkerAccountSummaryServices, IFrequentParkerAccountSummaryService } from './services/frequent-parker-account-summary-service';
import { UserAdminServices, IUserAdminService } from './services/user-service';
import { AccountsGridComponent, IAccountsGridController } from './account/accounts-grid';
import { AdminNavBarComponent } from './user-controls/admin-nav-bar';
import { AccountDetailComponent, IAccountDetailController } from './account/account-detail';
import { AccountsComponent, IAccountsController } from './account/accounts';
import { AdminComponent, IAdminController } from './admin';
import { DashboardComponent, IDashboardController } from './dashboard/dashboard';
import { DashboardDetailsComponent, IDashboardDetailsController } from './dashboard/dashboard-details';
import { DashboardGridComponent, IDashboardGridController } from './dashboard/dashboard-grid';
import { DenyMessageDialogComponent, IDenyMessageDialogController} from './pending-approval/deny-message-dialog';
import { PendingApprovalComponent, IPendingApprovalController } from './pending-approval/pending-approval';
import { PendingApprovalDetailsComponent, IPendingApprovalDetailsController } from './pending-approval/pending-approval-details';
import { PendingApprovalGridComponent, IPendingApprovalGridController } from './pending-approval/pending-approval-grid';
import { ContentNavWidgetComponent, IContentNavWidgetController } from './setup/content-nav-widget';
import { SetUpComponent, ISetUpController } from './setup/setup';
import { FppSettingsComponent, IFppSettingsController } from './setup/fpp-settings';
import { FppWidgetComponent, IFppWidgetController } from './setup/fpp-widget';
import { LandingComponent, ILandingController } from './setup/landing';
import { TimespanFormat } from './setup/timespan-formatter';
import { UsersComponent, IUsersController } from './users/users';
import { UsersDetailComponent, IUsersDetailController } from './users/users-detail';
import { UsersGridComponent, IUsersGridController } from './users/users-grid';
import { ContentEditorComponent } from './content-editor';

let adminModule = ng.module("app.admin", [
    refs.ngRouter,
    refs.ngMaterial,
    refs.ngMessages,
    refs.mdPickers,
    UserControlsModule.name
]).factory(AccountRequest.name, AccountRequest.factory)
    .factory(FrequentParkerAccountSummary.name, FrequentParkerAccountSummary.factory)
    .service(AccountRequestServices.name, AccountRequestServices.factory)
    .service(AccountAdminServices.name, AccountAdminServices.factory)
    .service(FrequentParkerAccountSummaryServices.name, FrequentParkerAccountSummaryServices.factory)
    .service(UserAdminServices.name, UserAdminServices.factory)
    .component(AccountsGridComponent.name, AccountsGridComponent.registration)
    .component(AdminNavBarComponent.name, AdminNavBarComponent.registration)
    .component(AccountDetailComponent.name, AccountDetailComponent.registration)
    .component(AccountsComponent.name, AccountsComponent.registration)
    .component(AdminComponent.name, AdminComponent.registration)
    .component(DashboardComponent.name, DashboardComponent.registration)
    .component(DashboardDetailsComponent.name, DashboardDetailsComponent.registration)
    .component(DashboardGridComponent.name, DashboardGridComponent.registration)
    .component(DenyMessageDialogComponent.name, DenyMessageDialogComponent.registration)
    .component(PendingApprovalComponent.name, PendingApprovalComponent.registration)
    .component(PendingApprovalDetailsComponent.name, PendingApprovalDetailsComponent.registration)
    .component(PendingApprovalGridComponent.name, PendingApprovalGridComponent.registration)
    .component(SetUpComponent.name, SetUpComponent.registration)
    .component(FppSettingsComponent.name, FppSettingsComponent.registration)
    .component(LandingComponent.name, LandingComponent.registration)
    .component(ContentNavWidgetComponent.name, ContentNavWidgetComponent.registration)
    .component(FppWidgetComponent.name, FppWidgetComponent.registration)
    .directive(TimespanFormat.name, TimespanFormat.factory)
    .component(ContentEditorComponent.name, ContentEditorComponent.registration)
    .component(UsersComponent.name, UsersComponent.registration)
    .component(UsersDetailComponent.name, UsersDetailComponent.registration)
    .component(UsersGridComponent.name, UsersGridComponent.registration);

export {
    IAccountRequestResource, IFrequentParkerAccountSummaryResource,
    IAccountRequestService, IAccountAdminService, IFrequentParkerAccountSummaryService, IUserAdminService,
    IAccountsGridController,
    IAdminController,
    IAccountDetailController, IAccountsController,
    IDashboardController, IDashboardDetailsController, IDashboardGridController,
    IDenyMessageDialogController,
    IPendingApprovalController, IPendingApprovalDetailsController, IPendingApprovalGridController,
    ISetUpController, IFppSettingsController, ILandingController,
    IFppWidgetController, IContentNavWidgetController,
    IUsersController, IUsersDetailController, IUsersGridController,
    adminModule
};
export default adminModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/index.ts